const Style = {
    filesViewerContainer: 'flex flex-wrap items-start justify-start gap-2 py-1',
    fileWrapper: 'group relative flex w-fit',
    closeButton: `absolute -right-1 -top-1 z-[1] rounded-full bg-error p-0.5 text-white opacity-0
        transition-opacity group-hover:opacity-100`,
    imageWrapper: 'relative h-16 w-[100px] overflow-hidden rounded-lg border border-border',
    image: 'h-full w-full cursor-pointer object-cover',
    textWrapper: `relative max-w-[10rem] truncate rounded-md border border-border bg-muted/30
        px-2 py-1.5 text-xs text-text-secondary`,
};

export default Style;
